module.exports = __webpack_public_path__ + "img/bonus-round-car.ec4ecbbb.png";